export default {
	nav: {
		features: "Features",
		screens: "Screens",
		plans: "Plans",
		faq: "FAQ",
		contact: "Contact",
		login: "Sign in",
		tryFree: "Try for free",
		lightMode: "Light mode",
		darkMode: "Dark mode",
	},
	hero: {
		eyebrow: "Management for Umbanda temples",
		titleLine1: "Tend to the axé.",
		titleLine2: "Let ORI tend to the management.",
		lead: "Visitors, mediumship chain, rituals, tickets, finances and communication — all in one place, honoring the traditions with the simplicity your temple deserves.",
		ctaPrimary: "Start free trial",
		ctaSecondary: "See the system from the inside",
		trust: "30 days free · no card required to get started",
		memberQuestion: "Got an invite from your temple?",
		memberLink: "Sign in as a member",
		shotAlt: "ORI dashboard",
	},
	features: {
		eyebrow: "Features",
		title: "Everything your temple needs",
		subtitle: "A system built for the day-to-day life of the temple — from registering a visitor to calling tickets on the hall's TV.",
		more: "And more: dashboard and reports · profile photos · follow-ups and tracking · available in 4 languages.",
		note: "Payments and WhatsApp alerts are optional add-ons. The fees on each Mercado Pago transaction are charged by the platform itself, not by ORI.",
		people: {
			title: "People and mediumship chain",
			text: "Visitors, mediums and members with complete profiles, photos and attendance history.",
		},
		journey: {
			title: "The medium's journey",
			text: "Track mediumistic development: spirit guides, orixás and growth milestones.",
		},
		rituals: {
			title: "Rituals and giras",
			text: "Ritual calendar, ritual types and attendance tracking for the mediumship chain.",
		},
		agenda: {
			title: "Public schedule & bookings",
			text: "Publish your rituals on a single link and take attendance bookings from consultants — with approval and seat control.",
		},
		tickets: {
			title: "Tickets and service",
			text: "Hand out tickets by spirit guide and medium, and print them on a thermal printer for less than a cent.",
		},
		tv: {
			title: "ORI TV — calls on the TV",
			text: "Ticket calls on the hall's TV, in real time and with a sound alert.",
		},
		financial: {
			title: "Finances",
			text: "Funds, contributions, dues and reports: your temple's books under control.",
		},
		payments: {
			title: "Payments via PIX",
			text: "Charge dues and contributions via PIX or card, with automatic reconciliation and recurring billing.",
		},
		whatsapp: {
			title: "WhatsApp notices",
			text: "Charges, confirmations and reminders on WhatsApp too, with each person's consent.",
		},
		assistant: {
			title: "AI assistant",
			text: "An assistant inside the system that answers questions and helps you set up your temple step by step.",
		},
	},
	screens: {
		eyebrow: "Inside look",
		title: "The screens you'll use every day",
		subtitle: "No fluff: this is what ORI actually looks like.",
		prev: "Previous",
		next: "Next",
		dashboard: {
			title: "Overview dashboard",
			desc: "Your temple at a glance: metrics, birthdays, upcoming rituals and charts.",
		},
		consulentes: {
			title: "Visitors",
			desc: "Search, filters and service history for each visitor.",
		},
		corrente: {
			title: "Mediumship chain",
			desc: "Mediums with their spiritual journey, orixás and roles in the temple.",
		},
		rituais: {
			title: "Rituals",
			desc: "Ritual details: status, type, tickets and statistics.",
		},
		agenda: {
			title: "Public schedule",
			desc: "A link where consultants see upcoming rituals and reserve a spot — no login.",
		},
		financeiro: {
			title: "Finances",
			desc: "Funds, goals, cash flow and charts in a single panel.",
		},
		pagamentos: {
			title: "Payments via PIX",
			desc: "Billing through Mercado Pago with automatic reconciliation and recurring charges.",
		},
		assistente: {
			title: "ORI Assistant",
			desc: "The AI that answers questions and helps you set up your temple step by step.",
		},
		atendimento: {
			title: "Ticket distribution",
			desc: "Tickets organized by spirit guide and the medium in charge.",
		},
		oritv: {
			title: "ORI TV",
			desc: "Ticket calls on the hall's TV — visitors follow when it's their turn.",
		},
		ticket: {
			title: "Printed ticket",
			desc: "Code, spirit guide, medium and time printed for less than a cent.",
		},
	},
	testimonials: {
		eyebrow: "Who uses it",
		title: "Temples that breathe easier",
		more: "read more…",
		less: "show less",
		prev: "Previous",
		next: "Next",
		jean: {
			p1: "Before using ORI, much of our time was consumed by manual administrative processes, such as managing rituals, services, financial control and countless other day-to-day tasks of the temple.",
			p2: "With ORI, all of that management became far simpler, more organized and more efficient. Today we can run everything with much more speed, security and ease.",
			p3: "The biggest benefit is that we no longer waste time on red tape and can devote our energy to what truly matters: charity, care, and spiritual service to people.",
			p4: "Congratulations to the whole team on their excellent work. I recommend ORI to every temple that wants to modernize its management without losing the foundation and essence of the religion.",
		},
		priscilla: {
			p1: "ORI came as an excellent tool for our temple when it comes to keeping track of attendees and their history.",
			p2: "Our temple has a rule of directing services to specific entities, and ORI helps me with the history, and even with the entities' requests for a visitor to come back.",
			p3: "On top of that, there's the registry of all the temple's mediums, birthday alerts, financial alerts for dues payments, and cash control, so in a single tool we get a full view of our entire operation.",
			p4: "For me, ORI made it easier to organize our data. As a religious organization we don't have someone dedicated solely to this, so our admins keep the system updated and it makes things easier for me whenever I need to gather accurate data all in one place.",
			p5: "I highly recommend it to spiritual leaders who, like me, have a busy professional life but won't give up on keeping our spiritual house always in order.",
		},
	},
	plans: {
		eyebrow: "Plans",
		title: "A plan that fits your temple",
		subtitle: "An ORI base plus whatever add-ons you want. The 30 free days apply to the base plan — no commitment and no card.",
		fallback: "We couldn't load the plans right now.",
		fallbackCta: "Try 30 days free",
	},
	faq: {
		eyebrow: "FAQ",
		title: "Frequently asked questions",
		trial: {
			q: "Can I try ORI?",
			a: "Yes. It's 30 days free on the base plan, no credit card. The add-ons — payments through Mercado Pago and WhatsApp alerts — aren't included in the trial.",
		},
		security: {
			q: "Is my data safe?",
			a: "Absolutely. We use encryption, per-temple isolation and automatic backups. No temple can access another temple's data.",
		},
		mobile: {
			q: "Does it work on phones and tablets?",
			a: "On tablets, the system works perfectly. The phone version is still evolving.",
		},
		tv: {
			q: "Can I call tickets on the TV?",
			a: "Yes. ORI has an app for Google TV or Fire TV that calls tickets in real time, and also displays personalized messages and videos for visitors.",
		},
		tickets: {
			q: "Can I use my physical tickets?",
			a: "You can use your own physical tickets or print them on a thermal printer for less than a cent per ticket — with code, spirit guide, medium and time, and even personalized messages.",
		},
		multiTemple: {
			q: "Can I use it in more than one temple?",
			a: "Yes. A single account can be linked to several temples with different roles, and each temple has its own plan and subscription.",
		},
		payments: {
			q: "Does ORI receive payments?",
			a: "Yes, through Mercado Pago. The integration is an optional add-on to the plan: you connect the temple's account and charge dues and contributions via PIX or card, with automatic reconciliation and recurring billing. The fees on each transaction are charged by Mercado Pago itself, and the money goes straight into the temple's account.",
		},
	},
	cta: {
		eyebrow: "Start today",
		title: "Ready to get your temple organized?",
		text: "Try ORI for 30 days, no commitment and no card. It takes just a few minutes to get started.",
		primary: "Create my temple",
		secondary: "Talk to us",
	},
	footer: {
		tagline: "Built by one child of Axé for another child of Axé.",
		invite: "I have an invite",
		manual: "Manual",
		terms: "Terms of Use",
		privacy: "Privacy Policy",
		cause: "We support the autism cause",
		causeAlt: "Autism Ribbon",
	},
};
